export { default } from "./ClickModal";
